import { PropsWithChildren, FunctionComponent, useId } from "react";
import { IconTextMenuItem } from "../floating-panel-menu/renderOptions/IconTextMenuItem.component";
import { FloatingPanelMenu } from "../floating-panel-menu/FloatingPanelMenu.component";
import { IButtonMenuProps } from "./interfaces/IButtonMenuProps";
import { IButtonMenuOption } from "./interfaces/IButtonMenuOption";
import "./styles/button-menu.css";

export const ButtonMenu: FunctionComponent<PropsWithChildren<IButtonMenuProps>> = (props) => {
    const defaultButtonId = useId();

    const buttonId = props.id !== undefined ? props.id : defaultButtonId;
    const activeClass = props.openStyle !== undefined ? props.openStyle : "";
    const buttonClass = `cui-button ${props.buttonStyle}`;
    const placement = props.placement !== undefined ? props.placement : "bottom-start";
    const buttonDataHook = props.buttonDataHook !== undefined ? props.buttonDataHook : "button-menu-button";
    const listDataHook = props.listDataHook !== undefined ? props.listDataHook : "button-menu-content-wrapper";

    return (
        <FloatingPanelMenu placement={placement} items={props.selectOptions}>
            <FloatingPanelMenu.Trigger
                isDisabled={props.disabled === true}
                id={buttonId}
                ariaLabel={props.ariaLabel !== undefined ? props.ariaLabel : ""}
                activeClass={activeClass}
                className={buttonClass}
                dataHook={buttonDataHook}>
                {props.children}
            </FloatingPanelMenu.Trigger>
            <FloatingPanelMenu.Panel>
                <FloatingPanelMenu.Menu<IButtonMenuOption> dataHook={listDataHook} renderer={IconTextMenuItem} ariaLabelledBy={buttonId} />
            </FloatingPanelMenu.Panel>
        </FloatingPanelMenu>
    );
};
